export default __webpack_public_path__ + "static/media/AddIcon.3bccfe59.svg";